var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTumblr = function SvgTumblr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.225 24C11.625 24 8.925 22.15 8.925 17.7V10.6H5.625V6.75C9.225 5.8 10.725 2.7 10.925 0H14.675V6.1H19.025V10.6H14.675V16.8C14.675 18.65 15.625 19.3 17.125 19.3H19.225V24H15.225Z",
    fill: "#001935"
  })));
};
export default SvgTumblr;